import { Routes } from '@angular/router';
import { CallbackComponent } from './core/components/auth-callback/auth-callback.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AppLayoutComponent } from './core/layout/app.layout.component';
import { LoginComponent } from './features/login/pages/login/login.component';
import { ProfileComponent } from './features/profile/profile.component';
import { UserStatusGuard } from './core/guards/user-status.guard';

export const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    redirectTo: 'sales/leads',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard, UserStatusGuard],
    children: [
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then((m) => m.routes),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: 'contacts',
        loadChildren: () => import('./features/contacts/contacts.routes').then((m) => m.routes),
      },
      {
        path: 'purchases',
        loadChildren: () => import('./features/purchases/purchases.routes').then((m) => m.routes),
      },
      {
        path: 'sales',
        loadChildren: () => import('./features/sales/sales.routes').then((m) => m.routes),
      },
      {
        path: 'properties',
        loadChildren: () => import('./features/properties/properties.routes').then((m) => m.routes),
      },
      {
        path: 'appointments',
        loadChildren: () => import('./features/appointments/appointments.routes').then((m) => m.routes),
      },
      { path: 'network', loadChildren: () => import('./features/network/network.routes').then((m) => m.routes) },
      { path: 'users', loadChildren: () => import('./features/users/users.routes').then((m) => m.routes) },
      { path: 'sources', loadChildren: () => import('./features/sources/sources.routes').then((m) => m.routes) },
      { path: 'sites', loadChildren: () => import('./features/sites/sites.routes').then((m) => m.routes) },
      {
        path: 'document-settings',
        loadChildren: () => import('./features/document-settings/documents.routes').then((m) => m.routes),
      },
      {
        path: 'invoicing',
        loadChildren: () => import('./features/invoicing/invoicing.routes').then((m) => m.routes),
      },
      {
        path: 'fees',
        loadChildren: () => import('./features/fees/fees.routes').then((m) => m.routes),
      },
      {
        path: 'fees-settings',
        loadChildren: () => import('./features/fees-settings/fees-settings.routes').then((m) => m.routes),
      },
      {
        path: 'microzones',
        loadChildren: () => import('./features/microzones/microzones.routes').then((m) => m.routes),
      },
      // Disabilitata: componente non presente nel progetto corrente
    ],
  },
];
